<template>
  <div class="container-fluid">
    <Breadcrumbs main="Overlap Sessions" :path="breadcrumbPath" />
    
    <el-row class="m-0 width-100-p mt-3">
      <el-col class="d-flex align-item-center px-2" :span="24">
        <div class="row m-0 width-100-p">
          <div
            class="row mt-3 py-3 width-100-p bg-me-primary border-color-light rounded-4"
            :style="$vuetify.display.width <= 768 ? 'margin-bottom: 20px;' : $vuetify.display.width < 1440 ? 'margin-bottom: 24px' : 'margin-bottom: 30px'"
            v-if="
              $store.state.auth.user != null &&
              !$store.state.auth.user.is_auditor"
          >
            <el-col class="mb-2" :span="24"                     
              >
              <div class="row m-0">
                <el-col
                  v-if="$vuetify.display.width < 700"
                  :span="24"
                  class="d-flex align-item-center"
                >
                  <el-button
                    v-if="
                        $store.state.auth.user != null &&
                        !$store.state.auth.user.is_auditor
                      "
                    color="#ddf0ac"
                    @click.stop="handleOverlapCheck"
                    size="small"
                    class="height-40 width-40-p rounded-2 m-0"
                  >
                    <i class="fa fa-upload pr-2"></i>
                    <span class="moderat-btn-apply"> Update </span>
                  </el-button>
                  <el-button
                    v-if="
                        $store.state.auth.user != null &&
                        !$store.state.auth.user.is_auditor
                      "
                    class="height-40 width-20-p rounded-2 m-0 ml-8px"
                    size="default"
                    @click="handleExportFile"
                    color="#ddf0ac"
                  >
                    <svg style="width: 17px; height: 21px;">
                        <use href="@/assets/svg/icon-sprite.svg#excel-icon"></use>
                    </svg>
                  </el-button>

                  
                  <el-button
                    v-if="
                          $store.state.auth.user != null &&
                          !$store.state.auth.user.is_auditor
                        "
                    color="#ddf0ac"
                    @click.stop="handleRemoveOverlap"
                    size="small"
                    class="height-40 width-25-p rounded-2 m-0 ml-8px"
                  >
                  <i class="fa fa-remove pr-2"></i>
                    <span class="moderat-btn-apply"> Remove </span>
                  </el-button>

                  <el-button
                    color="#ddf0ac"
                    @click.stop="handleReload"
                    size="small"
                    class="height-40 width-25-p rounded-2 m-0 ml-8px"
                  >
                    <i class="fa fa-refresh pr-2"></i>
                    <span class="moderat-btn-apply"> Refresh </span>
                  </el-button>
                </el-col>
                

                <el-col
                  v-if="$vuetify.display.width >= 700"
                  :span="$vuetify.display.width >= 1200 ? 14 : $vuetify.display.width >= 1600 ? 8 : 24"
                  style="max-width: 800px;"
                  class="d-flex align-item-center"
                  :class="
                    $vuetify.display.width < 750
                      ? 'x-center mt-2'
                      : 'justify-start'
                  "
                >
                  <el-button
                    v-if="
                        $store.state.auth.user != null &&
                        !$store.state.auth.user.is_auditor
                      "
                      color="#ddf0ac"
                      @click.stop="handleOverlapCheck"
                      size="small"
                      class="height-40 width-30-p rounded-2 m-0 ml-8px"
                    >
                      <i class="fa fa-upload pr-2"></i>
                      <span class="moderat-btn-apply"> Update </span>
                  </el-button>
                  <el-button
                    v-if="$vuetify.display.width < 1200"
                    class="height-40 rounded-2 m-0 ml-8px"
                    size="small"
                    @click="handleExportFile"
                    color="#ddf0ac"
                  >
                    <svg style="width: 17px; height: 21px;">
                        <use href="@/assets/svg/icon-sprite.svg#excel-icon"></use>
                    </svg>
                  </el-button>
                  <el-button
                    v-if="$vuetify.display.width >= 1200"
                    class="height-40 width-10-p rounded-2 m-0 ml-8px"
                    size="small"
                    @click="handleExportFile"
                    color="#ddf0ac"
                  >
                    <svg style="width: 17px; height: 21px;">
                        <use href="@/assets/svg/icon-sprite.svg#excel-icon"></use>
                    </svg>
                  </el-button>
                  <el-select
                    v-if="
                          $store.state.auth.user != null &&
                          !$store.state.auth.user.is_auditor
                        "
                    class="height-40 width-40-p rounded-2 m-0 ml-8px"
                    v-model="removeAction"
                    placeholder="Select Remove Actions"
                    size="large"
                    style="width: 70px"
                    @change="setRemoveActions"
                  >
                    <el-option v-for="(item, index) in removeActions" :key="index" :label="convertLabels(item.value)" :value="item.value" />
                    <!-- <el-option label="all" :value="'10'" />
                    <el-option label="charger" :value="'25'" />
                    <el-option label="item" :value="'50'" /> -->
                  </el-select>
                  
                  <el-button
                    v-if="
                          $store.state.auth.user != null &&
                          !$store.state.auth.user.is_auditor
                        "
                    color="#ddf0ac"
                    @click.stop="handleRemoveOverlap"
                    size="small"
                    class="height-40 width-30-p rounded-2 m-0 ml-8px"
                  >
                    <i class="fa fa-remove pr-2"></i>
                    <span class="moderat-btn-apply"> Remove </span>
                  </el-button>

                  <el-button
                    color="#ddf0ac"
                    @click.stop="handleReload"
                    size="small"
                    class="height-40 width-30-p rounded-2 m-0 ml-8px"
                  >
                    <i class="fa fa-refresh pr-2"></i>
                    <span class="moderat-btn-apply"> Refresh </span>
                  </el-button>
                </el-col>
             

              </div>
            </el-col>
            <el-col :span="24">
                  <el-select
                    v-if="
                          $store.state.auth.user != null &&
                          !$store.state.auth.user.is_auditor && $vuetify.display.width < 700
                        "
                    class="height-40 width-100-p rounded-2 m-0 ml-8px"
                    v-model="removeAction"
                    placeholder="Remove Actions"
                    size="large"
                    style="width: 300px"
                    @change="setRemoveActions"
                  >
                    <el-option v-for="(item, index) in removeActions" :key="index" :label="convertLabels(item.value)" :value="item.value" />
                    <!-- <el-option label="all" :value="'10'" />
                    <el-option label="charger" :value="'25'" />
                    <el-option label="item" :value="'50'" /> -->
                  </el-select>
            </el-col>
          </div>

            <DataTable
              :loadingProp="loading"
              :usersDataProp="overlapAnalysticData"
              :totalRowProp="total_items"
              @tableAction="handleTableAction"
            />
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import Breadcrumbs from "../../../components/bread_crumbs.vue";
// import XLSX from "xlsx";
import { exportMultipleDataLists } from "../common/exportExcel";
import UserService from "../../../services/user.service";
import DataTable from "./dataTable.vue";
import { convertToTitleCase } from "../common/common-tools";
import { ElMessageBox } from "element-plus";
// import moment from "moment";



export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "users",
  components: {
    Breadcrumbs,
    DataTable,
  },
  data() {
    return {
      removeActions: [      
        { value: "remove_over_24_hours" },
        { value: "remove_below_1kwh" },
        { value: "remove_second_sessions" }
      ],
      // removeActions: [      
      //   { value: "1" },
      //   { value: "2" },
      //   { value: "3" }
      // ],
      removeAction: '',

      breadcrumbPath: [
        {
          title: "General",
          disabled: true,
          href: "/dashboard",
        },
        {
          title: "Overlap Sessions",
          disabled: false,
          href: "dashboard-overlap-sessions",
        },
      ],

      show: true,
      sessionDataList: [],
      search: "",
      current_page: 1,
      page_size: 50,
      total_items: 100,
      loading: false,

      current_row_index: null,
      filterOpen: false,
      customers: [],
      filter: {
        customer_id: [],
        usage_KWh_from: null,
        usage_KWh_to: null,
        search: "",
      },

      OverlappingSessionsAnalytics: {
        overlapPerCharger: [],
        allOverlaps: [],
        overlapPairs: [],
      },

    };
  },

  computed: {
    overlapAnalysticData() {
      return this.OverlappingSessionsAnalytics;
    },

    
  },
  mounted() {
    this.fetchOverlapSessionData();
    this.handleResetRemoveAction();
  },
  methods: {
    convertLabels(value) {
      return convertToTitleCase(value);
    },
    setRemoveActions(value) {
      this.removeAction = value;
    },
    // dropdown table

    // dropdown table end


    changePage() {
      this.handleReload();
    },

    async handleOverlapCheck() {
      ElMessageBox.alert("The update request is submitted. The tables below will be updated in a few minutes.", "Request Sent", {
            confirmButtonText: "OK",
            type: "success",
          }).then(()=> {return;}).catch(()=>{return;});
      await this.requestOverlapCheck();
      this.handleReload();
    },

    handleReload() {
      this.fetchOverlapSessionData();
   
    },

    handleResetRemoveAction() {
      this.removeAction = "";
    },

    handleRemoveOverlap() {
      this.removeOverlapSessions(this.removeAction);
      this.handleReload();
      this.handleResetRemoveAction();
    },

    async requestOverlapCheck(){

      await UserService.OverlappingSessionsRunOverlapCheck()
        .then(
       
          (response) => {
            console.log("run overlap check", response.message);
          },
          (error) => {
            this.loading = false;
            console.log(error);
            if (error.response.status == 401) {
              this.$router.push({
                path: "/",
              });
            }
          }
        ).catch((error) => {
          this.loading = false;
          console.log(error);
          if (error.response.status == 401) {
            this.$router.push({
              path: "/",
            });
          }
        })
        .finally(() => (this.loading = false));

    },

    async fetchOverlapSessionData() {

      await UserService.OverlappingSessionsAnalytics()
        .then(
          (response) => {
            this.OverlappingSessionsAnalytics.overlapPerCharger = response.data.overlap_per_charger;
            this.OverlappingSessionsAnalytics.allOverlaps = response.data.all_overlaps;
            this.OverlappingSessionsAnalytics.overlapPairs = response.data.overlap_pairs;
            // console.log("get overlap analystics", response);

          },
          (error) => {
            this.loading = false;
            console.log(error);
            if (error.response.status == 401) {
              this.$router.push({
                path: "/",
              });
            }
          }
        )
        .catch((error) => {
          this.loading = false;
          console.log(error);
          if (error.response.status == 401) {
            this.$router.push({
              path: "/",
            });
          }
        })
        .finally(() => (this.loading = false));
    },
    async removeOverlapSessions(action) {
      if (action === "") {

        console.log("Select action is empty");
        return ElMessageBox.alert("Please select a remove action from the dropdown list before remove!", "Warning", {
            confirmButtonText: "OK",
            type: "warning",
          }).then(()=> {return;}).catch(()=>{return;});
      }
      await UserService.OverlappingSessionRemoveOverlaps(action)
        .then(
          (response) => {
            // console.log(response.data.message);
            if(response.data.status === "success") {
              const message = response.data.message;
              return ElMessageBox.alert(message, {
                confirmButtonText: "OK",
                type: "success",
              }).then(()=> {return;}).catch(()=>{return;});
            } else {
              if(response.data.status === "error") {
                const error_message = response.data.message;
                return ElMessageBox.alert(error_message, {
                  confirmButtonText: "OK",
                  type: "error",
                }).then(()=> {return;}).catch(()=>{return;});
              }
            }
          },
          (error) => {
            this.loading = false;
            console.log(error);
            if (error.response.status == 401) {
              this.$router.push({
                path: "/",
              });
            }
          }
        )
        .catch((error) => {
          this.loading = false;
          console.log(error);
          if (error.response.status == 401) {
            this.$router.push({
              path: "/",
            });
          }
        })
        .finally(() => (this.loading = false));
    },
    handleTableAction(event) {
      if (event.kind == "edit") {
        // this.handleShow(event.index, event.data);
        this.handleUpdate(event.index, event.data);
      } else if (event.kind == "delete") {
        this.deleteRow(event.data, event.index);
      } else if (event.kind == "changePage") {
        this.current_page = event.index;
        this.fetchOverlapSessionData(this.current_page);
      } else if (event.kind == "perPageChange") {
        this.current_page = 1;
        this.perPageCount = event.index;
        this.handleReload();
      }
    },

    async handleExportFile() {

      const tableData = {
        OverlapPerCharger: [],
        AllOverlaps: [],
        OverlapPairs: [],
      };

     if(this.OverlappingSessionsAnalytics.overlapPerCharger.length > 0) {
       const table_overlapPerCharger = this.OverlappingSessionsAnalytics.overlapPerCharger;
       tableData.OverlapPerCharger = table_overlapPerCharger;
     }
     if(this.OverlappingSessionsAnalytics.allOverlaps.length > 0) {
       const table_allOverlaps = this.OverlappingSessionsAnalytics.allOverlaps;
       tableData.AllOverlaps = table_allOverlaps;
     }
     if(this.OverlappingSessionsAnalytics.overlapPairs.length > 0) {
       const table_overlapPairs = this.OverlappingSessionsAnalytics.overlapPairs;
       tableData.OverlapPairs = table_overlapPairs;
     }

     const tableNames = {
      OverlapPerCharger: "Overlap per Charger",
      AllOverlaps: "All Overlaps",
      OverlapPairs: "Overlap Pairs",
     };

     const skipKeysList = {
      OverlapPerCharger: ["customer"],
      AllOverlaps:[],
      OverlapPairs: ["customer_id","port_name"],
     };

     try {
          await exportMultipleDataLists({
              title: "Overlap Session Report",
              tableData,
              tableNames,
              skipKeysList,
              fileName: "OverlapSessionReport.xlsx",
              });
              console.log("Excel file generated successfully!");
          } catch (error) {
              console.error("Error generating Excel file:", error);
      }
 },

 
    // handleExportFile() {
     
    //     // const myHeader = [];
    //     const wb = XLSX.utils.book_new();

    //     if(this.OverlappingSessionsAnalytics.overlapPerCharger.length > 0) {
    //       const sheet_overlapPerCharger = XLSX.utils.json_to_sheet(this.OverlappingSessionsAnalytics.overlapPerCharger);
    //       XLSX.utils.book_append_sheet(wb, sheet_overlapPerCharger, "OverlapPerCharger");
    //     }
    //     if(this.OverlappingSessionsAnalytics.allOverlaps.length > 0) {
    //       const sheet_allOverlaps = XLSX.utils.json_to_sheet(this.OverlappingSessionsAnalytics.allOverlaps);
    //       XLSX.utils.book_append_sheet(wb, sheet_allOverlaps, "AllOverlaps");
    //     }
    //     if(this.OverlappingSessionsAnalytics.overlapPairs.length > 0) {
    //       const sheet_overlapPairs = XLSX.utils.json_to_sheet(this.OverlappingSessionsAnalytics.overlapPairs);
    //       XLSX.utils.book_append_sheet(wb, sheet_overlapPairs, "OverlapPairs");
    //     }

    //     XLSX.writeFileXLSX(wb, "OverlappingSessionsList.xlsx");
      
    // },
  },
};
</script>

<style></style>
